import React from "react";
import "./carousel.css";
import airbnbLogoImg from "../../images/Airbnb_logo_new.svg";
import bookingLogoImg from "../../images/Booking.com_logo_new.svg";
import expediaLogoImg from "../../images/Expedia_2012_logo_new.svg";
import homeAwayLogoImg from "../../images/HomeAway_logo_new.svg";
import tripAdvisorLogoImg from "../../images/tripadvisor-logo-vector_new.svg";

const CarouselSection = () => {
  return (
    <section id="carousel">
      <div className="carousel-wrapper">
        <div className="logo-carousel-fader">
          <div className="logo-carousel">
            <div className="logo-track">
              <img className="expedia-img" src={expediaLogoImg} alt="Expedia" />
              <img className="homeaway-img" src={homeAwayLogoImg} alt="HomeAway" />
              <img className="airbnb-img" src={airbnbLogoImg} alt="Airbnb" />
              <img className="tripadvisor-img" src={tripAdvisorLogoImg} alt="Tripadvisor" />
              <img className="booking-img" src={bookingLogoImg} alt="Booking.com" />
              <img className="expedia-img" src={expediaLogoImg} alt="Expedia" />
              <img className="homeaway-img" src={homeAwayLogoImg} alt="HomeAway" />
              <img className="airbnb-img" src={airbnbLogoImg} alt="Airbnb" />
              <img className="tripadvisor-img" src={tripAdvisorLogoImg} alt="Tripadvisor" />
              <img className="booking-img" src={bookingLogoImg} alt="Booking.com" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CarouselSection;